export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-arrows-out-610dc429a8ff4ab57fde9c84ed72364c.svg";